import { render, staticRenderFns } from "./VolumeReverse.vue?vue&type=template&id=9667128e&"
import script from "./VolumeReverse.vue?vue&type=script&lang=js&"
export * from "./VolumeReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports